module.exports = __webpack_public_path__ + "img/telephones.542499e0.svg";